/** Domain-agnostic URL helper — pass base from deployment/vertical config. */
export function absoluteUrl(baseUrl: string, path: string): string {
  const base = baseUrl.replace(/\/$/, '');
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
